import React, { useEffect, useRef } from 'react';
import './BrowserModal.css';
import { FaTimes } from 'react-icons/fa';
import tribunnewsNewLogo from '../media/tribunnews_new.svg';
import detikcomNewLogo from '../media/detikcom_new.svg';
import liputan6NewLogo from '../media/liputan6_new.svg';
import kompasNewLogo from '../media/kompas_new.svg';
import cnnIndonesiaNewLogo from '../media/cnn_indonesia_new.svg';
import cnbcNewLogo from '../media/cnbc_new.svg';
import placeholderLogo from '../media/placeholder.svg';

function BrowserModal({ item, onClose, currentTime }) {
    const iframeRef = useRef(null);

    // Handle iframe content size adjustment
    useEffect(() => {
        const iframe = iframeRef.current;

        const adjustIframeSize = () => {
            const modalContent = iframe.closest('.modal-content');
            const headerElement = modalContent.querySelector('.modal-header');
            const availableHeight = modalContent.clientHeight - (headerElement?.offsetHeight || 0);
            iframe.style.height = `${availableHeight}px`;
            iframe.style.width = '100%'; // Full width of modal
        };

        adjustIframeSize();
        window.addEventListener('resize', adjustIframeSize);

        return () => {
            window.removeEventListener('resize', adjustIframeSize);
        };
    }, []);

    // Get appropriate logo for the news source
    const getLogoUrl = (source) => {
        if (!source) return placeholderLogo;

        if (source.includes("detik")) {
            return detikcomNewLogo;
        } else if (source.includes("tribun")) {
            return tribunnewsNewLogo;
        } else if (source.includes("liputan6")) {
            return liputan6NewLogo;
        } else if (source.includes("kompas")) {
            return kompasNewLogo;
        } else if (source.includes("cnn")) {
            return cnnIndonesiaNewLogo;
        } else if (source.includes("cnbc")) {
            return cnbcNewLogo;
        }
        return placeholderLogo;
    };

    // Get source name for display
    const getSourceName = (source) => {
        if (!source) return "Unknown";

        if (source.includes("detik")) {
            return "detikcom";
        } else if (source.includes("tribun")) {
            return "tribunnews";
        } else if (source.includes("liputan6")) {
            return "liputan6";
        } else if (source.includes("kompas")) {
            return "kompas";
        } else if (source.includes("cnn")) {
            return "cnnIndonesia";
        } else if (source.includes("cnbc")) {
            return "cnbcIndonesia";
        }
        return source;
    };

    // Format date similar to NewsCardRevamped
    const formattedDate = currentTime.toLocaleDateString('id-ID', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const formattedTime = currentTime.toLocaleTimeString('id-ID', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).replace(/\./g, ':');

    const shortTime = formattedTime.substring(0, 5); // Get only HH:MM format
    const sourceName = getSourceName(item.source);

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div className="article-title-container">
                        <h2 className="article-title">{item.title}</h2>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
                <div className="publisher-bar">
                    <div className="publisher-info">
                        {/* Logo beside publisher name */}
                        <div className="publisher-logo">
                            <img src={getLogoUrl(item.source)} alt="News Source Logo" loading="lazy" />
                        </div>
                        <div className="publisher-details">
                            <span className="publisher-name">{sourceName}</span>
                            <span className="date-separator"> · </span>
                            <span className="publish-date">{formattedDate} - {shortTime}</span>
                        </div>
                    </div>
                </div>
                <div className="browser-container">
                    <iframe
                        ref={iframeRef}
                        // src={`http://localhost:5000/api/rss/proxy?url=${encodeURIComponent(item.link)}`}
                        src={`/.netlify/functions/proxy?url=${encodeURIComponent(item.link)}`}
                        title="News Content"
                        className="browser-iframe"
                    />
                </div>
            </div>
        </div>
    );
}

export default BrowserModal;